import React, { useState } from "react";
import {
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import "../shared/BrandModal.css";

export const ApproveModal = (props) => {
  const [shortname, setShortname] = useState("");
  const [showShortnameError, setShowShortnameError] = useState(false);
  const [shortnameError, setShortnameError] = useState("");

  const toggle = () => {
    props.setToggle(!props.toggle);
  };

  const submitted = async (e) => {
    e.preventDefault();

    let validated = validate();

    if (!validated) {
      return;
    }
    let result = await props.onSubmit(props.accountId, shortname);
    if (result !== null) {
      setShortnameError(result);
      setShowShortnameError(true);
      return;
    }
    toggle();
  };

  const validate = () => {
    let isSuccess = true;

    if (!shortname) {
      setShowShortnameError(true);
      setShortnameError("Required");
      isSuccess = false;
    }

    return isSuccess;
  };

  return (
    <Modal isOpen={props.toggle} toggle={toggle} size="lg" className="brand-modal">
      <ModalHeader toggle={toggle}>Approve Account</ModalHeader>
      <ModalBody>
        <p className="brand-modal__desc">
          Enter the short name to approve this account.
        </p>
        <Form onSubmit={submitted}>
          <FormGroup>
            <Label for="shortnameId">Short name</Label>
            <Input
              type="edit"
              name="shortnameId"
              id="shortnameId"
              placeholder="Short name"
              onChange={(e) => setShortname(e.target?.value)}
              value={shortname}
            />
            {showShortnameError && (
              <p className="text-danger">{shortnameError}</p>
            )}
          </FormGroup>

          <div className="brand-modal__actions">
            <button type="submit" className="brand-modal__btn brand-modal__btn--success">
              <FontAwesomeIcon icon={faCheck} /> Approve
            </button>
            <button type="button" className="brand-modal__btn brand-modal__btn--cancel" onClick={() => toggle()}>
              <FontAwesomeIcon icon={faTimes} /> Close
            </button>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  );
};
